module.exports = __webpack_public_path__ + "static/img/contact.95c81f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/index/contact.png
// module id = xjGh
// module chunks = 202